export default "__VITE_ASSET__B7B6nEVA__"